'use client';
import { useEffect } from 'react';

 import Header from'@/components/common/Header';
 import Footer from'@/components/common/Footer';
 import HeroSection from'./components/HeroSection';
 import FastLaneSection from'./components/FastLaneSection';
 import ModelsGridSection from'./components/ModelsGridSection';
 import BusinessUseCasesSection from'./components/BusinessUseCasesSection';
 import TurnKeySolutionsSection from'./components/TurnKeySolutionsSection';
 import PaymentTimelineSection from'./components/PaymentTimelineSection';
 import FinalCTASection from'./components/FinalCTASection';
 import WhatsAppButton from'./components/WhatsAppButton';

export default function Homepage() {
  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('active')
          io.unobserve(e.target)
        }
      }),
      { threshold: 0.1 }
    )

    // Observe every not-yet-revealed `.reveal` element. We key the dedup off the
    // `.active` class (not a separate `.observed` flag) so that re-running this
    // effect — e.g. React StrictMode's double mount or a client-side re-mount —
    // always re-observes elements instead of leaving them permanently hidden.
    const observeAll = () => {
      document.querySelectorAll('.reveal').forEach(el => {
        if (!el.classList.contains('active')) io.observe(el)
      })
    }

    observeAll()

    const mo = new MutationObserver(observeAll)
    mo.observe(document.body, { childList: true, subtree: true })

    // Safety net: if IntersectionObserver never fires for some reason, reveal
    // everything after a short delay so content can never get stuck invisible.
    const fallback = setTimeout(() => {
      document.querySelectorAll('.reveal:not(.active)').forEach(el => el.classList.add('active'))
    }, 1200)

    return () => { io.disconnect(); mo.disconnect(); clearTimeout(fallback) }
  }, [])

  return (
    <>
      <Header />
      <main className="pt-20">
        <HeroSection />
        <FastLaneSection />
        <ModelsGridSection />
        <BusinessUseCasesSection />
        <TurnKeySolutionsSection />
        <PaymentTimelineSection />
        <FinalCTASection />
      </main>
      <Footer />
      <WhatsAppButton />
    </>
  )
}